module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAARVBMVEUAAADd3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d1j2hCcAAAAFnRSTlMA9T96p5f36i8S+Rfrvq6FXVFFLgwHndeqDQAAAHZJREFUKM/F0rsSgzAMRNFVogA2SXj7/z+VGYrdAWNK2PbMrSQEr9LpKg/wVNwf6vIW6WK3Yjf3RXwDqIm5jSxzexnRfpYZcULzPRgxLkBT703lB5vKiFKZUEojSlsaUUoTUmVCaTvYY8cW2tVrehkdweM5RQ8rNMo5v9mAzfoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/wx_wx_grey.png
// module id = 2DUM
// module chunks = 0